"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMergedCarListingOfferByFilterFormData = exports.filterListingOffers = void 0;
const ListingOffersList_1 = __importDefault(require("@react/web/Listing/ListingOffersList/ListingOffersList"));
const PageUrlHelper_1 = __importDefault(require("@react/web/Listing/PageUrlHelper/PageUrlHelper"));
const SortingTypes_1 = __importDefault(require("@react/web/Listing/Sorting/SortingTypes"));
const FilterCountUpdater_1 = __importDefault(require("@react/web/Listing/Filter/FilterCountUpdater"));
const FilterByFormData_1 = __importDefault(require("@react/web/Listing/Filter/FilterByFormData"));
function filterListingOffers(listingOffersList, filterFormData, mergedCarListingOffer, sortBy, pushToHistory) {
    if (pushToHistory) {
        PageUrlHelper_1.default.pagePushHistory(filterFormData, sortBy, mergedCarListingOffer);
    }
    if (mergedCarListingOffer !== null) {
        const filteredOffers = FilterByFormData_1.default.filterOffers(filterFormData, [mergedCarListingOffer], true);
        const offersList = new ListingOffersList_1.default(filteredOffers);
        FilterCountUpdater_1.default.updateFilterCount(filterFormData, listingOffersList, true);
        if (offersList.hasListingOffers()) {
            if (sortBy === SortingTypes_1.default.CHEAPEST) {
                offersList.sortByCheapest();
                offersList.listingOffers.map((carListingOffer) => carListingOffer.simpleOfferList.sortByCheapest());
            }
            if (sortBy === SortingTypes_1.default.BEST_SELLING) {
                offersList.sortByBestSelling();
                offersList.listingOffers.map((carListingOffer) => carListingOffer.simpleOfferList.sortByBestSelling());
            }
        }
        return offersList;
    }
    const filteredOffers = FilterByFormData_1.default.filterOffers(filterFormData, listingOffersList.listingOffers, false);
    const offersList = new ListingOffersList_1.default(filteredOffers);
    FilterCountUpdater_1.default.updateFilterCount(filterFormData, listingOffersList, false);
    if (offersList.hasListingOffers()) {
        if (sortBy === SortingTypes_1.default.CHEAPEST) {
            offersList.sortByCheapest();
            offersList.listingOffers.map((carListingOffer) => carListingOffer.simpleOfferList.sortByCheapest());
        }
        if (sortBy === SortingTypes_1.default.BEST_SELLING) {
            offersList.sortByBestSelling();
            // sortByCheapest is used on purpose, because other code (eg. ListingOffersListView.tsx), rely on first
            // offer to be cheapest, for showing "price from" correctly.
            offersList.listingOffers.map((carListingOffer) => carListingOffer.simpleOfferList.sortByCheapest());
        }
    }
    offersList.updateDatalayerPositionInfo();
    return offersList;
}
exports.filterListingOffers = filterListingOffers;
function getMergedCarListingOfferByFilterFormData(listingOffersList, filterFormData) {
    let offers = FilterByFormData_1.default.createListingOffersCopy(listingOffersList.listingOffers);
    if (filterFormData.getSelectedMakes().length === 1
        && filterFormData.getSelectedModels().length === 1
        && filterFormData.getSelectedBodyTypes().length === 1) {
        offers = offers.filter((offer) => offer.makeSlug === filterFormData.getSelectedMakes()[0].value);
        offers = offers.filter((offer) => offer.modelSlug === filterFormData.getSelectedModels()[0].value);
        offers = offers.filter((offer) => offer.bodyType === filterFormData.getSelectedBodyTypes()[0].value);
        if (offers.length === 1) {
            return offers[0];
        }
    }
    return null;
}
exports.getMergedCarListingOfferByFilterFormData = getMergedCarListingOfferByFilterFormData;
